import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL || 'http://localhost:8081/graphql';
const isDevelopment = process.env.NODE_ENV === 'development';

const httpLink = createHttpLink({
  uri: GRAPHQL_URL,
  credentials: 'include',
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (isDevelopment) {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        console.error(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        );
      });
    }
    if (networkError) {
      console.error(`[Network error]: ${networkError}`);
    }
  }
});

const cache = new InMemoryCache({ addTypename: false });

export const client = new ApolloClient({
  link: from([errorLink, httpLink]),
  cache,
  connectToDevTools: isDevelopment,
});
